import { useQuery } from 'libs/react';
import { CustomFormFieldGroup } from './CustomFormFieldGroup';
import { Text } from 'components/Text';
import { FieldGroupsValuesQuery } from 'graphql/FieldGroup/queries/FieldGroupsValuesQuery';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { When } from 'components/util/When';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { Icon } from 'components/Icon';
import { Spinner } from 'components/Spinner';
import './CustomFieldForm.scss';
/**
 * @component CustomFieldForm
 * @since 1.0.0
 * @hidden
 */
export function CustomFieldForm(props) {
    const { entity, entityId, functionValue, hideGroupTitle, populate, fields, onBlur, onChange, fromPublic, translable } = props;
    const [data, ready, error] = useQuery(FieldGroupsValuesQuery, {
        variables: {
            input: {
                query: [
                    {
                        field: 'category',
                        value: entity
                    }
                ]
            },
            valueInput: {
                entityId
            }
        },
        skip: !entityId
    });
    const groups = fields !== null && fields !== void 0 ? fields : data === null || data === void 0 ? void 0 : data.fieldGroups;
    return (React.createElement(Fragment, null,
        React.createElement(When, null,
            React.createElement(Case, { is: !ready },
                React.createElement(Spinner, { className: "custom-field-form-spinner" })),
            React.createElement(Case, { is: groups && groups.length > 0 }, groups === null || groups === void 0 ? void 0 : groups.map((group) => (React.createElement(CustomFormFieldGroup, { key: group.id, functionValue: functionValue, group: group, hideGroupTitle: hideGroupTitle, populate: populate, onBlur: onBlur, onChange: onChange, fromPublic: fromPublic, translable: translable })))),
            React.createElement(Else, null,
                React.createElement("div", { className: "custom-field-form-no-data-container" },
                    React.createElement(Icon, { className: "custom-field-form-icon", value: "fal user-circle" }),
                    React.createElement(Text, { className: "custom-field-form-text", value: t('This entity has no custom fields.') }),
                    React.createElement(Text, { className: "custom-field-form-text", value: t('Go to field groups to create your first one.') }))))));
}
